<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">

      <div class="avatar-wrapper">
        <div style="text-align: center;line-height: 43px;float: left;margin-right: 10px">
          {{this.$store.state.user.name}}
        </div>
        <img class="user-avatar" :src="renIcon">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="openDialog" style="display:block;">修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog append-to-body title="修改密码" :show-close="true" :visible.sync="dialogVisible" class="search-dialog"
               :close-on-click-modal="false">
      <el-card class="filter-container" shadow="never" @close="closeDialog">
        <div style="margin-top: 15px">

          <el-form :inline="true" :model="defaultData" size="small" label-width="140px">

            <el-form-item label="密码：">
              <el-input
                autoComplete="on"
                show-password v-model="defaultData.passWord"
                placeholder="请输入密码"
                type="password"
              ></el-input>
            </el-form-item>


          </el-form>
          <div class="search-dialog-btns">
            <el-button
              type="primary"
              @click="confirmBlack"
              size="small">确认
            </el-button>
          </div>
        </div>
      </el-card>

    </el-dialog>

  </el-menu>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'
  import renIcon from '@/assets/images/ren-icon.png'
  import {updateAdminPwd} from '@/api/login';

  export default {
    data() {
      return {
        renIcon,
        dialogVisible: false,
        defaultData: {
          passWord: null,
        },
        userName: ""
      }
    },
    components: {
      Breadcrumb,
      Hamburger
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'avatar'
      ])
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('ToggleSideBar')
      },
      logout() {
        this.$store.dispatch('FedLogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      openDialog() {
        this.dialogVisible = true;
      },
      confirmBlack() {
        if (this.defaultData.passWord == null || this.defaultData.passWord == "") {
          this.$message({
            message: '请输入新密码！',
            type: 'warning'
          });
          return;
        }
        if (this.defaultData.passWord.trim().length < 6) {
          this.$message({
            message: '登录密码不得少于6位！',
            type: 'warning'
          });
          return;
        }
        this.$confirm("确认修改密码", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {pWd: this.defaultData.passWord.trim(), userId: this.$store.state.user.usercode}
          updateAdminPwd(params).then(response => {
            this.dialogVisible = false;
            this.logout();
          });

        })
      },
      closeDialog() {
        this.dialogVisible = false;
        this.defaultData = Object.assign({}, defaultData);
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;

    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }

    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }

    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;

      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue